
<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     车间选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select
    v-model="workshopid"
    :placeholder="placeholder"
    :size="size"
    filterable
    clearable
    @change="selectChange"
    style="width: 100%;"
  >
    <el-option
      v-for="(item, index) in workshops"
      :key="index"
      :label="item.title"
      :value="item.workshopid"
    ></el-option>
  </el-select>
</template>

<script>
import { workshopGetallApi } from "@/api/em/monitorApi";

export default {
  name: "WorkshopSelector",

  props: {
    value: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    size: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      workshops: [],
    };
  },

  computed: {
    workshopid: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      workshopGetallApi().then((res) => {
        if (!res.errno) {
          // const temp = {
          //   workshopid: 0,
          //   title: '全体车间'
          // }
          this.workshops = res.data.list;
          // this.workshops.unshift(temp)
        }
      });
    },

    selectChange(val) {
      const list = this.workshops.map((v) => v.workshopid);
      const index = list.indexOf(val);
      const item = this.workshops[index];
      this.$emit("change", item);
    },
  },
};
</script>